export { defineLocale, getSetGlobalLocale, listLocales } from './locale/locales.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/index.js
// module id = 1003
// module chunks = 3